import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import { BackPage, OrderBar } from 'components';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import chevronBlack from 'assets/chevron-right-black.svg';
import * as Types from 'helpers/types';

const SelectPharmacy = () => {
  const history = useHistory();
  const { pharmacyList, paymentJourney } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [pharmacyListState, setPharmacyListState] = useState(
    pharmacyList.map((pharmacy) => Object.assign(pharmacy, { display: false }))
  );
  const listOfDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  useEffect(() => {
    if (!paymentJourney.started) history.push('/pharmacy/dashboard');
  }, [history, paymentJourney.started]);

  const handlePharmacySelect = (e, address) => {
    e.stopPropagation();
    updateAddress(e, address);
    dispatch({ type: Types.CLEAR_PAYMENT_AND_EXEMPTION })
    dispatch({ type: Types.DELIVERY_METHOD_SET, payload: "collectFromPharmacy" });
    history.push('/pharmacy/dashboard/basket');
  }

  const updateAddress = (e, address) => {
    e.stopPropagation();
    const formattedAddress = { ...address, ...address.address };
    delete formattedAddress.address;
    dispatch({ type: Types.ADDRESS_SET, payload: formattedAddress });
  };

  const groupBy = function (objectsToGroup, key) {
    return objectsToGroup.reduce(function (objectToGroup, x) {
      (objectToGroup[x[key]] = objectToGroup[x[key]] || []).push(x);
      return objectToGroup;
    }, {});
  };

  const toggleOpeningHours = (id) => {
    var updatedPharmacyList = pharmacyListState.map((pharmacy, index) => {
      if (id === index) {
        return { ...pharmacy, display: !pharmacy.display };
      }
      return pharmacy;
    });
    setPharmacyListState(updatedPharmacyList);
  };

  const displayAllHoursAvailable = (listOfHours) => {
    const hoursReducer = (accumulator, currentValue, currentIndex) => {
      return currentIndex === 0
        ? accumulator + `${currentValue.from} - ${currentValue.to}`
        : accumulator + `, ${currentValue.from} - ${currentValue.to}`;
    };
    return listOfHours.reduce(hoursReducer, '');
  };

  const displayOpeningHours = (normalHours) => {
    if (normalHours.length === 0) {
      return <ul className={styles.opening_hours}>Opening times not available</ul>;
    }
    const dateGrouped = groupBy(normalHours, 'date');
    return (
      <ul className={styles.opening_hours}>
        {listOfDays.map((day, index) => (
          <li key={index} className={styles.hours_container}>
            <p>
              {!dateGrouped[day] || dateGrouped[day][0].closed ? 'Closed' : displayAllHoursAvailable(dateGrouped[day])}
            </p>
            <p>{day}</p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <OrderBar currentProgress={0} />
      <BackPage onBackClick={() => history.push('/pharmacy/dashboard/find-pharmacy')}>
        <h1 className={styles.header}>Choose a pharmacy</h1>
        <ul className={styles.pharmacylist_container}>
          {pharmacyListState.map((pharmacy, index) => (
            <li key={index} className={`${styles.box_container} drop-shadow`}>
              <div
                className={styles.box_container__grid}
                tabIndex="0"
                onKeyPress={(e) => (e.key === 'Enter' ? handlePharmacySelect(e, pharmacy) : null)}
                onClick={(e) => handlePharmacySelect(e, pharmacy)}>
                <div>
                  <p className={styles.pharmacyText}>{pharmacy.distance_in_km} km</p>
                  <h2 className={styles.pharmacyName}>{pharmacy.name}</h2>
                  <p className={styles.pharmacyText}>{pharmacy.address.address_line1}</p>
                  <p className={styles.pharmacyText}>{pharmacy.address.address_line2}</p>
                  <p className={styles.pharmacyText}>
                    {pharmacy.address.address_line4 ? `${pharmacy.address.address_line4}, ` : null}
                    {pharmacy.address.postcode}
                  </p>
                  <p className={styles.pharmacyText}>{pharmacy.contact.phone_number}</p>
                </div>
                <div>
                  <img src={chevronBlack} className={styles.chevronImage} alt="select pharmacy" />
                </div>
              </div>

              {Object.keys(pharmacy.opening_times).length ? (
                <>
                  <hr className={styles.pharmacy_seperator} />
                  <div
                    className={`${styles.box_container__grid} ${styles.selectable}`}
                    tabIndex="0"
                    onKeyPress={(event) => (event.key === 'Enter' ? toggleOpeningHours(index) : null)}
                    onClick={(e) => toggleOpeningHours(index)}>
                    <p className={styles.pharmacyOpeningButton}>Opening Times</p>
                    <div className={styles.image_container}>
                      <img
                        src={chevronBlack}
                        className={pharmacy.display ? styles.chevronImageUp : styles.chevronImageDown}
                        alt="select pharmacy"
                      />
                    </div>
                  </div>
                  {pharmacy.display ? displayOpeningHours(pharmacy.opening_times.normal_hours) : null}
                </>
              ) : null}
            </li>
          ))}
        </ul>
      </BackPage>
    </>
  );
};

export default SelectPharmacy;
